import { render, staticRenderFns } from "./HomeHeroCopyBtn.vue?vue&type=template&id=f6fef97a&scoped=true&"
import script from "./HomeHeroCopyBtn.vue?vue&type=script&lang=js&"
export * from "./HomeHeroCopyBtn.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeroCopyBtn.vue?vue&type=style&index=0&id=f6fef97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fef97a",
  null
  
)

export default component.exports